import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "../lib/nav";

export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    const target = state?.scroll || hash.replace("#", "");
    const t = setTimeout(() => scrollToHash(target), target ? 260 : 80);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}